
    const html = "<div class=progress ng-transclude aria-labelledby={{::title}}></div>";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/progressbar/progress.html', html);
    }]);
    module.exports = 'uib/template/progressbar/progress.html';
  